import './siteheader.scss';

class Siteheader {
    constructor ($header) {
        this.$header = $header;

        this.$languageSwitch = this.$header.querySelector('[data-footer="language-switch"]');
        this.languageSwitch = undefined;
    }

    initialize () {
        if (this.$languageSwitch) {
            this.bindEvents();
        }
    }

    bindEvents () {
        this.$languageSwitch.addEventListener('change', (e) => {
            const $selectedOption = this.$languageSwitch.options[e.srcElement.selectedIndex];
            if ($selectedOption) {
                const url = $selectedOption.value;
                this.changeUrlLocation(url);
            }
        });
    }

    changeUrlLocation (url) {
        window.location.assign(url);
    }
}

export default Siteheader;
